/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImagePreview/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ImagePreview({
  children,
  viewPath = "/DesignSystem/CommsThreadEventAttachments/Content/Attachment/ImageAttachment/PreviewAttachment/Content/ImagePreview",
  value
  
}) {
  return (<React.Fragment
>
<div
  data-testid="ImagePreview.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<img
  data-testid="ImagePreview.Image"
  data-view-path={viewPath}
 alt={""}
 src={value}
 className={`views-block ${styles.Image}`}
/>
</div>
{children}
</React.Fragment>)
}